module.exports = __webpack_public_path__ + "static/strangerThinksBG-7a02c92e2eb7c8d100924c17e060f792.jpg";